<template>
  <NuxtLayout name="markup">
    <MarkupGenerator :page-data="markupData || undefined" :is-page="true" />
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { general_setPageTheme } from '~/utils/general/pageThemeClassFromMarkup';

definePageMeta({
  layout: false,
});

const { $api } = useNuxtApp();
const config = useRuntimeConfig();
const notifications = useNotificationStore();
const route = useRoute();
const routeManufacturerSlug = route.params.manufacturer;

let manufacturerSlug = '';
if (Array.isArray(routeManufacturerSlug)) {
  const slugCopy = [...routeManufacturerSlug];
  manufacturerSlug = slugCopy.join('/');
} else {
  manufacturerSlug = routeManufacturerSlug;
}

const { data: markupData, error } = await useAsyncData(
  `/mobiltelefoner/${manufacturerSlug}`,
  async () => {
    return await $api.manufacturerModule.getManufacturerPage(manufacturerSlug);
  },
  {
    transform: cache_addFetchedAtTransform,
    getCachedData: cache_getCachedDataFromServer,
  },
);

if (error.value) {
  throw createError({
    statusCode: error.value.statusCode,
    fatal: true,
  });
}

if (!markupData.value) {
  throw createError({
    statusCode: 404,
    fatal: true,
  });
}

filters_initializeFiltersIfListComponentExists(markupData.value, false);
general_setPageTheme(markupData.value?.PageContent);

notifications.reset();

const canonicalUrl = `${config.public.apiBaseUrl.replace(/\/$/, '')}${route.fullPath.split('?')[0]}`;
const seoInput = {
  seoData: {
    title: markupData?.value?.MetaTitle,
    description: markupData?.value?.MetaDescription,
    siteName: 'Halebop',
    keywords: markupData?.value?.MetaKeywords,
    canonicalUrl,
  },
  fallBackSeoData: {
    title: `Köp din ${route.params.manufacturer} med abonnemang | Fri frakt | Halebop.se`,
    description: `Köp din ${route.params.manufacturer} med abonnemang | Fri frakt | Halebop.se`,
    siteName: 'Halebop',
    keywords: '',
    canonicalUrl,
  },
};
useCustomSeoMeta(seoInput);
</script>

<style></style>
